import React from "react";
import { Box } from "@mui/material";
import SurveyImageCapture from "./SurveyImageCapture";

const SurveyImages = ({
  question,
  answer,
  onChange,
  disabled,
  testMode = false,
}) => {
  // Parse config JSON string
  const parseConfig = (configStr) => {
    if (!configStr) return {};
    if (typeof configStr === "object") return configStr;
    try {
      return JSON.parse(configStr);
    } catch (e) {
      console.error("Error parsing question config:", e);
      return {};
    }
  };

  const config = parseConfig(question.config);

  // Normalize answer value to JSON string format for SurveyImageCapture
  const normalizeValue = (val) => {
    if (!val) return "[]";
    if (typeof val === "string") return val;
    if (Array.isArray(val)) return JSON.stringify(val);
    if (typeof val === "object") return JSON.stringify(val);
    return "[]";
  };

  const handleChange = (newValue) => {
    // Parse the JSON string and emit in the expected format
    try {
      const parsed = JSON.parse(newValue);
      onChange(parsed);
    } catch (e) {
      console.error("Error parsing image value:", e);
    }
  };

  return (
    <Box>
      <SurveyImageCapture
        value={normalizeValue(answer?.value)}
        onChange={handleChange}
        imageType={config.imageType || "standard"}
        minImages={config.minImages || 0}
        maxImages={config.maxImages || 10}
        resolution={config.resolution || "high"}
        disabled={disabled}
      />
    </Box>
  );
};

export default SurveyImages;
